import {
  RECEIVE_DAILY_CONDITIONS,
  RECEIVE_HOURLY_CONDITIONS,
  RECEIVE_CURRENT_CONDITIONS,
  FAILURE_WEATHER_CONDITIONS,
} from '../constants/actionTypes';

export const initialState = {
  currentConditions: {},
  hourlyConditions: {},
  dailyConditions: {},
  error: undefined,
};

export default function weatherForecastReducer(
  state = initialState,
  action = {}
) {
  switch (action.type) {
    case FAILURE_WEATHER_CONDITIONS: {
      return {
        ...state,
        error: action.error,
      };
    }

    case RECEIVE_CURRENT_CONDITIONS: {
      const {
        dew_point: dewPoint,
        humidity,
        temperature,
        weather_condition: weatherCondition,
        wind_direction: windDirection,
        wind_speed: windSpeed,
      } = action.currentConditions;
      return {
        ...state,
        currentConditions: {
          dewPoint,
          humidity,
          temperature,
          weatherCondition,
          windSpeed,
          windDirection: windDirection && {
            ...windDirection,
            q: windDirection.q - 180,
          },
        },
      };
    }

    case RECEIVE_HOURLY_CONDITIONS: {
      const { attributes, variables } = action.hourlyConditions;
      return {
        ...state,
        hourlyConditions: {
          ...variables,
          firstForecastTime: attributes.first_forecast_time,
          weatherCondition: variables.weather_condition,
          dewPoint: variables.dew_point,
          windDirection: variables.wind_direction,
          windSpeed: variables.wind_speed,
          precipitationProbability: variables.precipitation_probability,
        },
      };
    }

    case RECEIVE_DAILY_CONDITIONS: {
      const { attributes, variables } = action.dailyConditions;

      return {
        ...state,
        dailyConditions: {
          ...variables,
          firstForecastTime: attributes.first_forecast_time,
          weatherCondition: variables.weather_condition,
          minTemperature: variables.min_temperature,
          maxTemperature: variables.max_temperature,
          windDirection: variables.wind_direction,
          windSpeed: variables.wind_speed,
          precipitationProbability: variables.precipitation_probability,
          precipitationAmount: variables.precipitation_amount,
          sprayAssistIndex: variables.spray_assist_index,
        },
      };
    }

    default:
      return state;
  }
}
